/**
 * @file Web Gallery Analytics Container.
 */

import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import get from 'lodash.get';
import mixpanel from 'mixpanel-browser';

import Mixpanel from '../../../util/mixpanel';
import { AccountForWebGalleries } from '../graphql/queries/account';
import getConfig from '../../../util/config';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    username: PropTypes.string,
    email_address: PropTypes.string,
  }),
};

const config = getConfig();
const consumerMixpanelToken = get(config, 'mixpanel.consumer', null);
const WebGalleryMixPanel = Mixpanel(
  mixpanel,
  'consumer',
  consumerMixpanelToken,
);

const WebGalleryAnalyticsInit = ({ user }) => {
  const userId = get(user, 'id');

  useEffect(() => {
    if (userId) {
      WebGalleryMixPanel.identify(userId);
      WebGalleryMixPanel.people.set({
        $name: user.name,
        $username: user.username,
        $email: user.email_address,
      });
    }
  }, [userId]);

  return null;
};

WebGalleryAnalyticsInit.propTypes = propTypes;

const withUserDetails = graphql(AccountForWebGalleries, {
  props: ({ data: { me } }) => {
    return {
      user: me,
    };
  },
  skip: ownProps => !ownProps.authenticated,
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export { WebGalleryMixPanel };

export default compose(
  connect(mapStateToProps),
  withUserDetails,
)(WebGalleryAnalyticsInit);
